// Export the Component Definition for use in Contentful Studio
export {ActionBlockContentfulComponentDefinition} from './actionBlockContentfulDefinition';
export {default} from './ActionBlock';
